// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-project-form {
  width: 100%;
}

.field-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}
.field-row--indented {
  padding-left: 24px;
}

.field-label {
  flex: 0 0 140px;
  padding-top: 6px;
  font-size: 0.85rem;
}

.field-value {
  flex: 1;
}

.radio-group {
  display: flex;
  gap: 16px;
  padding-top: 6px;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.85rem;
  cursor: pointer;
}

.field-error {
  color: #dc3545;
  font-size: 0.75rem;
  margin-top: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/edit-project/edit-project.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;AACJ;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,OAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AAAF","sourcesContent":[".edit-project-form {\n  width: 100%;\n}\n\n.field-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 12px;\n\n  &--indented {\n    padding-left: 24px;\n  }\n}\n\n.field-label {\n  flex: 0 0 140px;\n  padding-top: 6px;\n  font-size: 0.85rem;\n}\n\n.field-value {\n  flex: 1;\n}\n\n.radio-group {\n  display: flex;\n  gap: 16px;\n  padding-top: 6px;\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.field-error {\n  color: #dc3545;\n  font-size: 0.75rem;\n  margin-top: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
